// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"a81821dc","232":"3187fb2a","237":"447e032f","526":"5e377b22","787":"28cb0dcd","872":"975285f0"}[chunkId] + ".chunk.js";
};